import { useWebItemLocation } from '@confluence/web-item-location/entry-points/useWebItemLocation.ts';

import { getGlobalAppsParams } from './getGlobalAppsParams.ts';

type UseWebItemsWithUrlsReturnType = Omit<ReturnType<typeof useWebItemLocation>, 'webSections'>;

export const useWebItemsWithUrls: ({
	accessStatus,
	edition,
}: {
	accessStatus: any;
	edition: any;
}) => UseWebItemsWithUrlsReturnType = ({ accessStatus, edition }) => {
	const { webItemParams } = getGlobalAppsParams({
		edition,
		accessStatus,
	});

	const { webItems, loading, error } = useWebItemLocation(webItemParams);

	return {
		webItems: !webItems
			? []
			: webItems.map((item) => ({
					...item,
					url: item?.url ? item.url.split('?')[0] : '',
				})),
		loading,
		error,
	};
};
